export default {
  cookiecontent: `我們在網站及其他線上服務上使用
    Cookie，以確保其正確運作，並確保您能充分利用我們的網站。我們亦使用 Cookie
    來分析使用者如何使用及互動我們的網站，並啟用社交媒體功能。您可以選擇接受或拒絕這些
    Cookie，或自定義您允許的 Cookie 類型。請注意，若您拒絕某些
    Cookie，可能會無法完全使用網站的功能。
    <a href="/cookie" target="_blank">《Cookie政策》</a>。`,
  同意: "同意",
  拒绝: "拒絕",
  Cookie政策: "Cookie 政策",
  本Cookie政策说明EBCFinancial: `本 Cookie 政策說明 EBC Financial Group（以下稱「EBC」、「我們」或「本公司」）如何在我們的網站 www.ebc.com（以下稱「本網站」）上使用 Cookie 與類似技術。`,
  什么是Cookie: "1. 什麼是 Cookie？",
  Cookie是当您浏览EBC: `Cookie 是當您瀏覽 EBC 網站時儲存在您裝置（如計算機或手機）上的小型文件檔案。這些檔案普遍用來提高網站效能，並向網站擁有者提供資訊。`,
  您可透过以下网站了解更多: "您可透過以下網站了解更多 Cookie 資訊：",
  我们使用的Cookie类型: "2. 我們使用的 Cookie 類型",
  tabletop: "",
  Cookie类型: "Cookie類型",
  说明: "說明",
  必要Cookie: "必要 Cookie",
  此类Cookie是网站正常运作所必需: `這類 Cookie 是網站正常運作所必需，無法關閉。它們通常會在您進行例如填寫表單或設定隱私選項等操作時被啟用。您可以透過瀏覽器封鎖這些 Cookie，但網站的某些功能可能無法正常使用。`,
  效能分析Cookie: "效能（分析）Cookie  ",
  此类Cookie协助我们计算访客数与流量来源: `此類 Cookie 協助我們計算訪客數與流量來源，以改善網站效能與內容。我們能藉此了解哪些頁面受歡迎，使用者如何瀏覽網站等。  `,
  功能性Cookie: "功能性 Cookie  ",
  使网站能提供更进阶的功能与个人化体验: `使網站能提供更進階的功能與個人化體驗。這些 Cookie 可能由我們設置，也可能由我們引入的第三方服務提供。若不允許這些 Cookie，部分服務可能無法正常使用。  `,
  tablebottom: "",
  如何管理Cookie: "3. 如何管理 Cookie  ",
  您有权决定是否接受Cookie:
    "您有權決定是否接受 Cookie。大多數瀏覽器提供以下功能：  ",
  查看装置上已安装的Cookie: "查看裝置上已安裝的 Cookie  ",
  删除Cookie: "刪除 Cookie  ",
  封锁Cookie: "封鎖 Cookie  ",
  设定特定网站的Cookie偏好: "設定特定網站的 Cookie 偏好  ",
  详细操作请参阅您的浏览器说明页:
    "詳細操作請參閱您的瀏覽器說明頁，或使用以下連結：  ",
  同意h2: "4. 同意  ",
  当您使用本网站: `當您使用本網站，即表示您同意我們在您的裝置上設置上述類型的 Cookie（除非您在瀏覽器中封鎖），並依本政策使用相關數據。  `,
  政策更新: "5. 政策更新  ",
  本Cookie政策可能因应实务或法律改变而更新: `本 Cookie
          政策可能因應實務或法律改變而更新。如有重大更動，我們將在網站上發布公告通知您。
          如您對本政策或我們使用 Cookie 有任何疑問，請聯絡：
          <a class="a-normal" href="mailto:cs@ebc.com">cs@ebc.com</a>`,
  最后更新时间: "最後更新時間：2025年6月  ",
};
